export default __webpack_public_path__ + "static/ctaModule_cloud_top_desktop-13b3e7470394336827899a7d37fd6008.webp";